<div class="d-flex analysis-layout">
  <!-- Left Sidebar Navigation -->
  <app-analysis-nav analysisType="capture" [config]="navConfig"> </app-analysis-nav>

  <!-- Main Content -->
  <div class="content-area">
    @if (projectFiles.length) {
      <div class="row p-3">
        <h2>Project Files</h2>
        <div class="row">
          <ul class="list-inline">
            @for (file of projectFiles; track file) {
              <div>
                <li class="list-inline-item">
                  <a href="#" (click)="downloadFile(file.file_path, file.file_name); $event.preventDefault()">
                    <fa-icon [icon]="file.file_icon"></fa-icon>
                  </a>
                  <button
                    (click)="copyLinkToClipboard(file.file_url)"
                    class="btn btn-link"
                    style="--bs-btn-padding-y: 0rem; --bs-btn-padding-x: 0rem"
                  >
                    <fa-icon [icon]="faCopy" [border]="false"></fa-icon>
                  </button>
                  {{ file.file_name }}
                </li>
              </div>
            }
          </ul>
        </div>
      </div>
    }

    <div class="row p-3">
      <h2>Project Samples</h2>
      <div class="table-controls">
        <div class="global-filter">
          <label class="visually-hidden" for="project-samples-global-filter">Search project samples</label>
          <input
            id="project-samples-global-filter"
            class="form-control"
            type="search"
            placeholder="Search all columns"
            [value]="globalFilter"
            (input)="onGlobalFilterChange($event, sampleTable)"
          />
        </div>
      </div>
      <div class="table-container">
        <p-table
          #sampleTable
          [value]="sampleRows"
          [columns]="sampleColumns"
          dataKey="sample_id"
          rowExpandMode="multiple"
          [paginator]="true"
          [rows]="initialRows"
          [rowsPerPageOptions]="rowsPerPageOptions"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [globalFilterFields]="globalFilterFields"
          (onRowExpand)="onSampleRowExpand($event)"
          class="project-samples-table"
        >
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th aria-label="Expand sample file details"></th>
              @for (column of columns; track column.data) {
                <th [pSortableColumn]="column.data">
                  <div class="table-header-content">
                    <span class="table-header-title">
                      {{ column.title }}
                      <p-sortIcon [field]="column.data"></p-sortIcon>
                    </span>
                  </div>
                </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
            <tr>
              <td>
                <button
                  class="btn btn-link sample-expansion-toggle"
                  type="button"
                  [pRowToggler]="rowData"
                  [attr.aria-expanded]="expanded"
                  [attr.aria-label]="(expanded ? 'Collapse' : 'Expand') + ' files for sample ' + rowData.sample_id"
                >
                  <fa-icon [icon]="expanded ? faChevronDown : faChevronRight"></fa-icon>
                </button>
              </td>
              @for (column of columns; track column.data) {
                <td>{{ rowData[column.data] }}</td>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="expandedrow" let-rowData>
            <tr class="sample-expansion-row">
              <td [attr.colspan]="sampleColumns.length + 1">
                <div class="sample-file-details">
                  @if (getSampleFilesState(rowData); as state) {
                    @switch (state.status) {
                      @case ('loading') {
                        <p role="status">Loading sample files...</p>
                      }
                      @case ('error') {
                        <p role="alert">Unable to load sample files. Collapse and re-expand this row to retry.</p>
                      }
                      @case ('loaded') {
                        @if (state.sections.length > 0) {
                          @for (section of state.sections; track section.title) {
                            <section class="sample-file-section" [style.margin-left.px]="section.depth * 24">
                              <h6>{{ section.title }}</h6>
                              @if (section.files.length > 0) {
                                <ul class="list-unstyled">
                                  @for (sampleFile of section.files; track sampleFile.filePath) {
                                    <li>
                                      <a
                                        href="#"
                                        [attr.aria-label]="'Download ' + sampleFile.fileName"
                                        (click)="
                                          downloadFile(sampleFile.filePath, sampleFile.fileName);
                                          $event.preventDefault()
                                        "
                                      >
                                        <fa-icon [icon]="sampleFile.fileIcon"></fa-icon>
                                      </a>
                                      <span>&nbsp;&nbsp;</span>{{ sampleFile.fileName }}
                                    </li>
                                  }
                                </ul>
                              }
                            </section>
                          }
                        } @else {
                          <p>No files are available for this sample.</p>
                        }
                      }
                    }
                  } @else {
                    <p role="status">Loading sample files...</p>
                  }
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length + 1">No project samples available.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<ng-template #content>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Link copied</h4>
  </div>
  <div class="modal-body">The download link has been copied to to your clipboard. It is valid for 24 hours.</div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modalRef.hide()">OK</button>
  </div>
</ng-template>
